import api from "@/service/Api/Api";
import { apiResponse } from "@/service/Api/Api";

export interface patchEditUserIdentifierRequest {
  user_identifier: string;
}

export interface patchEditUserIdentifierResponse {
  user_identifier: string;
}

export default {
  patchEditUserIdentifier(
    data: patchEditUserIdentifierRequest,
    volumeLicenseId: string,
    userId: string
  ): Promise<patchEditUserIdentifierResponse & apiResponse> {
    return api<patchEditUserIdentifierRequest, patchEditUserIdentifierResponse>(
      {
        endpoint:
          "volume-licenses/" + volumeLicenseId + "/users/web-api/" + userId,
        method: "PATCH",
        queryParams: data,
      }
    );
  },
};
